import { AutoSubmitFormik } from "../../../../components/FormikFields/AutoSubmitFormik.js";
import { FormikText } from "../../../../components/FormikFields/FormikText.js";
import { PersonFields } from "./components/PersonFields.js";
import { ItemFields } from "./components/ItemFields.js";
import { VehicleFields } from "./components/VehicleFields.js";
import "react";
import { Button, FormLayout, Icon } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { Formik } from "formik";
import * as Yup from "yup";
//#region src/modules/Records/shared/RecordSearchFilters/index.tsx
var ValidationSchema = Yup.object().shape({
	config: Yup.object().shape({ showAdvancedFilters: Yup.boolean() }),
	item: Yup.object().shape({
		color: Yup.string().nullable(),
		status: Yup.string().nullable(),
		tags: Yup.array().of(Yup.string())
	}),
	person: Yup.object().shape({
		ageFrom: Yup.number().nullable(),
		ageTo: Yup.number().nullable(),
		gender: Yup.string().nullable(),
		race: Yup.string().nullable(),
		tags: Yup.array().of(Yup.string())
	}),
	searchText: Yup.string(),
	vehicle: Yup.object().shape({
		color: Yup.string().nullable(),
		tags: Yup.array().of(Yup.string()),
		type: Yup.string().nullable(),
		yearFrom: Yup.number().nullable(),
		yearTo: Yup.number().nullable()
	})
});
var recordSearchFiltersDefaultValues = {
	config: { showAdvancedFilters: false },
	item: {
		color: "",
		status: "",
		tags: []
	},
	person: {
		ageFrom: void 0,
		ageTo: void 0,
		gender: "",
		race: "",
		tags: []
	},
	searchText: void 0,
	vehicle: {
		color: "",
		tags: [],
		type: "",
		yearFrom: void 0,
		yearTo: void 0
	}
};
function RecordSearchFilters({ onChange, tab }) {
	return /* @__PURE__ */ jsx(Formik, {
		onSubmit: onChange,
		validationSchema: ValidationSchema,
		initialValues: recordSearchFiltersDefaultValues,
		children: ({ resetForm, setFieldValue, submitForm, values }) => /* @__PURE__ */ jsx(FormLayout, {
			space: "0",
			children: /* @__PURE__ */ jsxs("div", {
				className: "space-y-xxs",
				children: [
					/* @__PURE__ */ jsx(AutoSubmitFormik, {}),
					/* @__PURE__ */ jsxs("div", {
						className: "gap-xxs pt-xs flex",
						children: [
							/* @__PURE__ */ jsx("div", {
								className: "grow",
								children: /* @__PURE__ */ jsx(FormikText, {
									name: "searchText",
									placeholder: "Search...",
									search: true
								})
							}),
							/* @__PURE__ */ jsxs(Button, {
								onClick: () => setFieldValue("config.showAdvancedFilters", !values.config.showAdvancedFilters),
								size: "base",
								subtle: true,
								variant: "neutral",
								children: [/* @__PURE__ */ jsx("span", {
									className: "mr-xxs text-sm",
									children: "Filters"
								}), /* @__PURE__ */ jsx(Icon, {
									Icon: values.config.showAdvancedFilters ? MdExpandLess : MdExpandMore,
									size: "sm"
								})]
							}),
							/* @__PURE__ */ jsxs(Button, {
								onClick: () => {
									resetForm();
									submitForm();
								},
								subtle: true,
								variant: "critical",
								children: [/* @__PURE__ */ jsx(Icon, {
									color: "critical",
									Icon: IoClose,
									size: "sm",
									className: "mr-xxs"
								}), /* @__PURE__ */ jsx("span", {
									className: "text-sm",
									children: "Clear All"
								})]
							})
						]
					}),
					tab === "person" && /* @__PURE__ */ jsx(PersonFields, {}),
					tab === "item" && /* @__PURE__ */ jsx(ItemFields, {}),
					tab === "vehicle" && /* @__PURE__ */ jsx(VehicleFields, {})
				]
			})
		})
	});
}
//#endregion
export { RecordSearchFilters, recordSearchFiltersDefaultValues };

//# sourceMappingURL=index.js.map